<template>
	<div class="lottery-page">
		<van-nav-bar class="nav-bar" :border="false">
			<template #left>
				<van-icon name="arrow-left" color="#fff" size="20" @click="back()" />
			</template>
			<template #title>
				<span class="title-text">{{ $t('lottery.name') }}</span>
			</template>
		</van-nav-bar>

		<section class="status-card">
			<div class="status-grid">
				<div class="status-cell">
					<div class="status-label">{{ $t('lottery.match_deadline') }}</div>
					<van-count-down class="status-time" format="HH:mm:ss" :time="time" @finish="check()" />
				</div>
				<div class="status-divider"></div>
				<div class="status-cell right">
					<div class="status-label">{{ $t('lottery.result') }}</div>
					<div class="status-result">
						<div class="bn" :class="calcBg(size)">{{ size }}</div>
           <div class="bn r" :class="calcBg(double)">{{ double }}</div>
          <div class="bn" :class="calcBg(sumShow)">{{ sumShow }}</div>
					</div>
				</div>
			</div>
		</section>

		<section class="play-grid">
			<button v-for="v in lottery_peilv_list" :key="v.type" class="play-button"
				:class="{ active: choose[v.type] }" type="button" @click="choosePlay(v.type, v.name)">
				{{ v.name }}
			</button>
		</section>

		<section class="hero-poster">
			<img :src="lottery.ico" alt="poster" />
		</section>

		<section class="selection-card">
			<div class="selection-title">{{ $t('lottery.current_selection') }}：</div>
			<div class="selection-body">
				<div class="money-field">
					<van-field v-model="money" placeholder="0.00" type="digit" />
				</div>
				<div class="hkd-field">HKD</div>
				<div class="balance-field">{{ $t('lottery.balance') }}：{{ userInfo.money || '0.00' }}</div>
			</div>
		</section>

		<footer class="action-bar">
			<div class="clear-btn" @click="allClear()">{{ $t("reservation.clear_order") }}</div>
			<div class="order-info">
				<!-- <span>{{ $t("reservation.available_balance") }}：{{ userInfo.money || '0.00' }}</span> -->
				<span class="order-count">共 {{ formData.length }} 部，共 {{ totalAmount }} HKD</span>
			</div>
			<!-- <button class="submit-btn" type="button" @click="jiesuan()">{{ $t("reservation.submit") }}</button> -->
			<button class="submit-btn" type="button" @click="doSub">{{ $t("reservation.submit") }}</button>
		</footer>

		<van-popup v-model="jiesuanpage" get-container="body">
			<div class="confirm-order-modal">
				<ul class="list">
					<li v-for="(v, key) in formData" :key="key" class="lise-item van-hairline--bottom">
						<div class="main">
							<p class="bet-name">{{ v.name }}</p>
							<p class="detail-text">
								1{{ $t("reservation.note") }}X{{ money }}{{ $t("reservation.unit") }}={{ money }}{{ $t("reservation.ge") }}
							</p>
						</div>
						<van-icon @click="clearChooes(v.type)" name="close" />
					</li>
				</ul>
				<div class="sub-bar">
					<van-button class="item cancel-btn" type="default"
						@click="allClear()">{{ $t("reservation.clear_order") }}</van-button>
					<van-button class="item sub-btn" type="default"
						@click="doSub">{{ $t("reservation.submit") }}</van-button>
				</div>
			</div>
		</van-popup>

		<van-popup v-model="active" position="top" :style="{ height: '70%' }">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="popup-list">
					<div class="popup-item" v-for="(v, key) in lottery_list" :key="key">
						<div class="popup-left">{{ v.expect }}</div>
						<div class="popup-right">
							<span class="ballBox">{{ v.opencode[0] }}</span>
							<span class="ballBox">{{ v.opencode[1] }}</span>
							<span class="ballBox">{{ v.opencode[2] }}</span>
							<span class="res-des">{{ v.opencode[0] + v.opencode[1] + v.opencode[2] }}</span>
							<span class="middle"
						:class="calcBgLs(v.opencode[0], v.opencode[1], v.opencode[2], 'type1')">
						{{ v.opencode[0] + v.opencode[1] + v.opencode[2] >= 11 ? $t('lottery.big') : $t('lottery.small') }}
					</span>
					<span class="middle"
						:class="calcBgLs(v.opencode[0], v.opencode[1], v.opencode[2], 'type2')">
						{{ (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0 ? $t('lottery.two') : $t('lottery.one') }}
					</span>
						</div>
					</div>
				</div>
			</van-pull-refresh>
		</van-popup>

		<van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
			<div class="game-list">
				<div class="game-item" v-for="(i, index) in gameitemData" :key="index" @click="tabList(i.id, i.key)">
					<div>{{ $t("q29") }}</div>
					<div class="game-meta">
						<div class="game-icon">
							<van-image width="60" height="61" :src="i.ico" />
						</div>
						<div class="game-name">{{ i.name }}</div>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks: "",
      choose: {
        '0': false,
        '1': false,
        '2': false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      sumShow: "",
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      ids: 11,
      keys: 5,
      gameitemData: [],
      userTimer:""
    };
  },
  mounted(){
    if(this.userTimer){
      clearInterval(this.userTimer);
      this.userTimer = ""
    }
    setInterval(()=>{
      this.getUserInfo()
    },10000)
   
  },
  methods: {
    toMine() {
      this.$router.push("/Mine")
    },
    back() {
      return window.history.back();
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {

      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      console.log(type, name);
      console.log(this.choose)
      // 处理 type 可能不在 choose 对象中的情况
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else {
        // 如果 choose[type] 是 false 或 undefined，都视为未选中状态
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
        console.log(this.shopchoose, 'ssss')

      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          console.log(this.userInfo,"---477")
          if(this.userInfo.is_online != 1){
            localStorage.clear()
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          let lottery_peilv_list = res.data;
          console.log("=== lottery_peilv_list 接口数据 ===");
          console.log(lottery_peilv_list, "lottery_peilv_list--508");
          // 检查数据结构
          if (lottery_peilv_list && lottery_peilv_list.length > 0) {
            console.log("第一个元素的结构:", Object.keys(lottery_peilv_list[0]));
            console.log("第一个元素:", lottery_peilv_list[0]);
          }
          let clist = [];
          let appItem = [
            { img: "/img/neww/huojian.gif", color: "#8948fb" },
            { img: "/img/neww/love.gif", color: "#ff6398" },
            { img: "/img/neww/youting.gif", color: "#2196f3" },
            { img: "/img/neww/meigui.gif", color: "#ff7d73" },
          ]
          lottery_peilv_list.map((itemc, key) => {
            itemc = {
              ...itemc,
              ...appItem[key]
            }
            clist.push(itemc)
          })
          this.lottery_peilv_list = clist;
          
          console.log("lottery_peilv_list:", this.lottery_peilv_list);
          
          // 数据加载完成后执行 sum 判断逻辑
          const lang = localStorage.getItem("lang") || 'zh';
          console.log('lang~~~',lang)
          if (this.sum !== 0) {
            this.processSumLogic(lang); 
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          console.log("lottery_list:");
          console.log(res.data);
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitemData = res.data;
        console.log(this.gameitemData, 'gameitemData')
      })
    },
    tabList(id, key) {
      this.ids = id
      this.keys = key
      this.showModel = false
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        const lanng = localStorage.getItem("lang") || 'zh';
        console.log(lanng,"lanng---552")
        if (res.code === 200) {
          if (
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          this.lottery = res.data;
          console.log(this.lottery, 'qweqweqw')
          this.time = res.data.second * 1000;

          // if (this.time / 1000 === 59) {
          //   this.$toast(
          //     this.$t("reservation.prize_succ") + this.lottery.now_expect
          //   );
          // }

          this.sum =
            res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
        //   this.sum = 4;
          
          // 如果 lottery_peilv_list 已经加载完成，立即执行判断逻辑
          if (this.lottery_peilv_list.length > 0) {
            this.processSumLogic(lanng);
          }
          // 如果还没加载完成，会在 getLotteryPeilv 完成后调用

        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        console.log(this.lottery, 9900)
      });
    },
    processSumLogic(lanng) {
      if (this.sum >= 11 && this.sum <= 18) {
        lanng == 'zh' ? this.size = '喜劇' : lanng == 'en' ? this.size = 'Comedy' : lanng == 'ja' ? this.size = 'コメディ' : this.size = '喜劇'

      } else if (this.sum >= 3 && this.sum <= 10) {
        lanng == 'zh' ? this.size = '科幻' : lanng == 'en' ? this.size = 'Sci-Fi' : lanng == 'ja' ? this.size = "SF" : this.size = '科幻'

      }
      if (this.sum % 2 === 0) {
        lanng == 'zh' ? this.double = "武俠" : lanng == 'en' ? this.double = "Martial Arts" : lanng == 'ja' ? this.double = "武術" : this.double = '武術';

      } else {
        lanng == 'zh' ? this.double = "動作" : lanng == 'en' ? this.double = "Action" : lanng == 'ja' ? this.double = "アクション" :
          this.double = "動作";
      }
      this.updateSumShow();
    },
    updateSumShow() {
      console.log('=== updateSumShow 开始 ===');
      console.log('lottery_peilv_list 长度:', this.lottery_peilv_list.length);
      console.log('lottery_peilv_list 内容:', this.lottery_peilv_list);
      console.log('sum 的值:', this.sum, '类型:', typeof this.sum);
      
      if (this.lottery_peilv_list.length === 0) {
        console.log('lottery_peilv_list 为空，无法匹配');
        this.sumShow = this.sum;
        return;
      }
      
      const matchedItem = this.lottery_peilv_list.find(item => {
        const itemType = Number(item.type);
        const sumVal = Number(this.sum);
        console.log(`比较: item.type=${item.type}(${itemType}) vs sum=${this.sum}(${sumVal})`);
        return itemType == sumVal;
      });
      
      console.log('matchedItem:', matchedItem);
      this.sumShow = matchedItem ? matchedItem.name : ' ';
      console.log('sumShow 的最终值:', this.sumShow);
      console.log('=== updateSumShow 结束 ===');
    },
    calcBg(el) {
      if (el == '喜劇' || el == 'Comedy' || el == 'コメディ' || el == '코미디') {
        return 'd'
      } else
        if (el == '科幻' || el == 'Sci-Fi' || el == "SF" || el == 'SF') {
          return 'x'
        } else
          if (el == "動作" || el == "Action" || el == "アクション" || el == "액션") {
            return 'v'
          } else
            if (el == "武俠" || el == "Martial Arts" || el == "武術" || el == "무협") {
              return 'r'
            } else {
              return 'r'
            }
    },
    calcBgLs(n1, n2, n3, type) {
      let zhi = n1 + n2 + n3;
      if (type == 'type1') {
        if (zhi >= 11 && zhi < 18) {
          return 'd'
        } else {
          return 'x'
        }
      }
      if (type == 'type2') {
        if (zhi % 2 == 0) {
          return 'v'
        } else {
          return 'r'
        }
      }
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
    }
    const lang = localStorage.getItem("lang") || 'zh';
    if (lang == 'zh') {
      this.rose = '玫瑰';
      this.lily = '百合';
      this.balloon = '氣球'
      this.fireworks = '煙花'
    } else if (lang == 'en') {
      this.rose = 'Rose';
      this.lily = 'Lily';
      this.balloon = 'Balloon'
      this.fireworks = 'Fireworks'
    } else if (lang == 'ja') {
      this.rose = 'ロケット';
      this.lily = "ハート";
      this.balloon = 'バラ'
      this.fireworks = 'ヨット'
    } else {
      this.rose = '장미';
      this.lily = '백합';
      this.balloon = '풍선'
      this.fireworks = '불꽃놀이'
    }

  },
  computed: {
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };

      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    },
    totalAmount() {
      const unit = parseFloat(this.money || 0);
      if (Number.isNaN(unit) || unit <= 0) {
        return 0;
      }
      return unit * this.formData.length;
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>
<style lang="less" scoped>
	@import "../../assets/css/base.css";

	.lottery-page {
		min-height: 100vh;
		background: #151515;
		color: #fff;
		padding-bottom: 76px;
		font-size: clamp(28px, 2vw, 34px);
	}
	.lottery-page,
	.lottery-page * {
		font-size: clamp(28px, 2vw, 34px) !important;
	}

	.nav-bar {
		background: #151515;
		padding:10px 0;
	}

	.title-text {
		color: #18d26a;
		font-size: 18px;
		font-weight: 700;
	}

	.status-card {
		margin: 0 0 10px;
		padding: 12px 8px 0;
		background: #181818;
		border-top: 1px solid #2d2d2d;
		border-bottom: 1px solid #2d2d2d;
	}

	.status-grid {
		display: flex;
		align-items: stretch;
		min-height: 96px;
		border: 1px solid #343434;
		background: #1b1b1b;
	}

	.status-cell {
		flex: 1;
		padding: 12px 10px 30px;
		text-align: center;
	}

	.status-cell.right {
		color: #19d66d;
	}

	.status-divider {
		width: 1px;
		background: rgba(255,255,255,.2);
		
		margin: 14px 0;
	}

	.status-label {
		font-size: 13px;
		color: #22cc61;
		margin-bottom: 8px;
	}

	.status-time {
		color: #22cc61;
		font-size:48px !important;
		font-weight: 500 !important;
		line-height: 1;
	}

	::v-deep .status-time,
	::v-deep .status-time * {
		color: #22cc61 !important;
		font-size: 40px;
		font-weight: 700;
		line-height: 1;
		font-variant-numeric: tabular-nums;
	}

	.status-result {
		color: #22cc61;
		font-size: 22px;
		font-weight: 700;
		line-height: 1.2;
		display: flex;
		justify-content: center;
	}

	.play-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 10px 12px;
		padding: 20px;
	}

	.play-button {
		border: 1px solid #4a4a4a;
		border-radius: 10px;
		background: #1b1b1b;
		color: #18d26a;
		font-size: 32px;
		font-weight: 500;
		padding:15px 0;
	}

	.play-button.active {
		border-color: #22cc61;
		background: rgba(34, 204, 97, 0.1);
	}

	.hero-poster {
		margin-top: 10px;
    padding-bottom: 200px;
	}

	.hero-poster img {
		display: block;
		width: 100%;
		height: 500px;
		background-color: #fff;
		object-fit: cover;
	}

	.selection-card {
		width:100vw;
		margin-top: 12px;
		padding: 0 10px 10px;
		border-top: 1px solid #2e2e2e;
		position: fixed;
		bottom:100px;
    background: #151515;
	}

	.selection-title {
		color: #18d26a;
		font-size: 14px;
		margin: 10px 0;
	}

	.selection-body {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.money-field {
		width: 200px;
	}
	.van-field__control{
		color:#fff !important; 
	}
	::v-deep .money-field .van-cell {
		padding: 6px 8px;
		height: 60px;
		border-radius: 10px;
		background: #111;
		color:#fff;
		border: 1px solid #18d26a;
	}
	::v-deep .money-field .van-cell .van-field__control{
		line-height: 50px;
		color:#1dc74a;
	}
	.hkd-field{
		padding:10px 20px;
		border: 1px solid #1dc74a;
		border-radius: 10px;
		color: #1dc74a;
		height: 60px;
		margin-left: 20px;
	}
	.balance-field {
		color: #18d26a;
		font-size: 28px;
		white-space: nowrap;
		margin-left: 50px;
	}

	.action-bar {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		display: grid;
		grid-template-columns: auto 1fr auto;
		align-items: stretch;
		height:100px;
		background: #343434;
		z-index: 20;
	}

	.submit-btn {
		border: 0;
		font-size: 24px;
		font-weight: 500;
		white-space: nowrap;
	}

	.clear-btn {
		color: #1dc74a;
		background: #343434;
		padding:10px 20px;
		margin:20px;
		border: 1px solid #1dc74a;
		border-radius: 10px;
	}

	.submit-btn {
		color: #1dc74a;
		background: #151515;
	}

	.order-info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 4px;
		padding: 0 10px;
		color: #22cc61;
		font-size: 14px;
		background: #343434;
	}

	.order-count {
		font-size: 13px;
	}

	.confirm-order-modal {
		width: 80vw;
		height: 70vh;
		display: flex;
		flex-direction: column;
		background: #fff;
		padding: 40px 15px 20px;
		border-radius: 30px;
	}

	.confirm-order-modal .list {
		flex: 1;
		padding: 0 10px;
		overflow-y: auto;
	}

	.confirm-order-modal .list .lise-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 10px 0;
	}

	.confirm-order-modal .list .lise-item .main {
		flex: 1;
		overflow: hidden;
	}

	.confirm-order-modal .list .lise-item .main .bet-name {
		color: #ff253f;
		font-size: 35px;
		font-weight: 500;
		line-height: 1.2;
		word-wrap: break-word;
		word-break: break-all;
	}

	.confirm-order-modal .list .lise-item .main .detail-text {
		line-height: 1.2;
		font-size: 25px;
		color: #979799;
	}

	.confirm-order-modal .sub-bar {
		display: flex;
		align-items: center;
		margin-top: 30px;
		justify-content: space-around;
	}

	.confirm-order-modal .sub-bar .item {
		min-width: 40%;
		height: 80px;
		text-align: center;
		box-sizing: border-box;
		border-radius: 50px;
		font-size: 35px;
		font-weight: 500;
	}

	.confirm-order-modal .sub-bar .item.cancel-btn {
		border: 2px solid #979799;
		color: #979799;
		background-color: #fff;
	}

	.confirm-order-modal .sub-bar .item.sub-btn {
		background: linear-gradient(20deg, #8673e5, #d958a4);
		color: #fff;
		border: 0;
	}

	.popup-list {
		padding: 10px;
	}

	.popup-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #fff;
		padding: 12px 0;
		border-bottom: 1px solid #2b2b2b;
	}

	.popup-left {
		min-width: 84px;
	}

	.popup-right {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
		justify-content: flex-end;
	}

	.ballBox {
		color: #e6b98a;
		font-weight: 700;
		font-size: 18px;
	}

	.res-des,
	.middle {
		font-size: 12px;
	}

	.middle.d {
		color: #22cc61;
	}

	.middle.x,
	.middle.v,
	.middle.r {
		color: #fff;
	}

	.game-list {
		padding: 16px;
	}

	.game-item {
		background: #1b1b1b;
		border: 1px solid #333;
		border-radius: 12px;
		padding: 14px;
		margin-bottom: 12px;
		color: #fff;
	}

	.game-meta {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-top: 10px;
	}

	.game-icon {
		width: 60px;
		height: 61px;
		overflow: hidden;
		border-radius: 8px;
		background: #fff;
	}

	.game-name {
		font-size: 14px;
	}
	.bn{
		margin-right: 10px;
	}
</style>